//Generated File 
export default class BusinessFunction{
	static readonly LogOut = `LogOut`;
	static readonly accept = `accept`;
	static readonly approval = `approval`;
	static readonly askAI = `askAI`;
	static readonly autoFitCols = `autoFitCols`;
	static readonly changeLocale = `changeLocale`;
	static readonly chooseSortFields = `chooseSortFields`;
	static readonly $delete = `delete`;
	static readonly duplicate = `duplicate`;
	static readonly exportAsDOCX = `exportAsDOCX`;
	static readonly exportAsODS = `exportAsODS`;
	static readonly exportAsODT = `exportAsODT`;
	static readonly exportAsPDF = `exportAsPDF`;
	static readonly exportAsPPTX = `exportAsPPTX`;
	static readonly exportAsRTF = `exportAsRTF`;
	static readonly exportAsTXT = `exportAsTXT`;
	static readonly exportAsXLS = `exportAsXLS`;
	static readonly exportAsXLSX = `exportAsXLSX`;
	static readonly filterAndSort = `filterAndSort`;
	static readonly first = `first`;
	static readonly generalSearch = `generalSearch`;
	static readonly go = `go`;
	static readonly goToRecord = `goToRecord`;
	static readonly homePage = `homePage`;
	static readonly last = `last`;
	static readonly listView = `listView`;
	static readonly more = `more`;
	static readonly newRecord = `newRecord`;
	static readonly next = `next`;
	static readonly previous = `previous`;
	static readonly print = `print`;
	static readonly printAs = `printAs`;
	static readonly refresh = `refresh`;
	static readonly removeFilter = `removeFilter`;
	static readonly reportRelaunch = `reportRelaunch`;
	static readonly reportZoomIn = `reportZoomIn`;
	static readonly reportZoomOut = `reportZoomOut`;
	static readonly resultSettings = `resultSettings`;
	static readonly revise = `revise`;
	static readonly rowAppend = `rowAppend`;
	static readonly rowDelete = `rowDelete`;
	static readonly rowDown = `rowDown`;
	static readonly rowInsert = `rowInsert`;
	static readonly rowUp = `rowUp`;
	static readonly save = `save`;
	static readonly saveAndContinue = `saveAndContinue`;
	static readonly sendEmailWithResult = `sendEmailWithResult`;
	static readonly showHelpMsgs = `showHelpMsgs`;
	static readonly toggleSortDirection = `toggleSortDirection`;
	static readonly tooltips = `tooltips`;
	static readonly treeView = `treeView`;
	static readonly unrevise = `unrevise`;
}
